import * as React from 'react';
import { nullSafeGetOrElse } from '../../utils/DataAccessUtils';
import { Popover } from 'antd';

export default function PrivateWorkOrderLock({ workOrder, style, fontSize }) {
	return nullSafeGetOrElse('isPrivate', workOrder, false) ? (
		<Popover
			title={'Private Work Order'}
			content={'Private work orders can only be seen by the work order subscribers.'}
			placement={'topLeft'}
		>
			<span style={style}>
				<i className="icons8-font icons8-lock" style={{ fontSize: fontSize }} />
			</span>
		</Popover>
	) : null;
}
